// extracted by mini-css-extract-plugin
export var bounce = "_oz-1";
export var generatingText = "_oz-6";
export var lightning = "_oz-4";
export var popup = "_oz-5";
export var progressBar = "_oz-7";
export var progressFill = "_oz-8";
export var progressShimmer = "_oz-9";
export var progressText = "_oz-a";
export var shimmer = "_oz-3";
export var uploadIcon = "_oz-0";
export var uploadingText = "_oz-2";